import React from 'react'
import TextEditor from '../../components/textEditor/TextEditor'

const Privacy = () => {
    return (
        <TextEditor tag_name="privacy_policy" />
    )
}

export default Privacy